import { createFileRoute } from "@tanstack/react-router";

import SettingsPage from "@/components/[routes]/settings/settings-page";

export const Route = createFileRoute("/_secure/settings")({
  component: SettingsPage,
});
